import Vue from 'vue'
import Vuex from 'vuex'
import customband from './modules/customband'
import alerts from './modules/alerts'
import customstates from './modules/customstates'
import art from './modules/art'
import createLogger from '../plugins/logger'
import cloneDeep from 'lodash/cloneDeep'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    customband,
    alerts,
    warnings: cloneDeep(alerts),
    customstates,
    art
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})
